import Logo from "../../../assets/img_0.avif"
import "./Loading.css"
const Loading = () => {
    return (
        <div className={"loading"}>
            <img src={Logo} alt=""/>
        </div>
    )
}
export default Loading;